define(function (require) {
	const Radio = require('backbone.radio');
	const dashboardChannel = Radio.channel('dashboardChannel');
	const ViewManager = require('civicsUtils/view_manager');
	const SaveSearchModalTemplate = require('./templates/t_cpv_save_search_modal.hbs');
	const extendedFilterUtility = require('civicsUtils/extended_filter_utility');

	const save_search_model = require('civicsModels/portal/saved_searches');
	const saved_searches_collection =  require('civicsCollections/portal/saved_searches_collection');

	return Marionette.CompositeView.extend({
		template: SaveSearchModalTemplate,
		ui: {
			saveButton: '.save-search-btn',
			cancelButton: '.cancel-save-search-btn',
			closeButton: '.bbm-btn-close',
			searchField: '.save-search-field input'
		},
		events: {
			'click @ui.saveButton': 'onSaveSearch',
			'click @ui.cancelButton': 'closeSaveSearchModal',
			'click @ui.closeButton': 'closeSaveSearchModal',
		},
		initialize: function (options) {
			this.config = options.config ? options.config : {};
			this.savedSearchesCollection = options.savedSearchesCollection;
			this.modalRegion = options.modalRegion;
			this.parentView = options.parentView;
			this.channel = Radio.channel(this.config.radioChannel);
		},
		onRender: function() {
			$(document).ready(() => {
				this.ui.searchField.focus();
			});

		},
		onSaveSearch: function () {
			const searchName = this.ui.searchField.val();

			// Get the current filter state
			const filterObj = this.channel.request('filter:getUrlParameters');
			const isFirstFilter = this.channel.request('filter:isFirstFilter');
			const minifiedFilter = filterObj ? extendedFilterUtility.minifyFilterString(JSON.stringify(filterObj)) : '';
			const isFilterEmpty = _.isEmpty(JSON.parse(minifiedFilter || "{}"));

			ViewManager.resetErrorMessages(this);

			if (!searchName) {
				ViewManager.errorToWindow({
					validationError: {
						"emptySearchName": i18n.t('CIVICS.COMMON.SAVE_SEARCH_EMPTY_SEARCH_NAME')
					}
				}, this);
				return;
			}

			// Check if the filter is empty
			if (isFirstFilter || isFilterEmpty) {
				ViewManager.errorToWindow({ validationError: { "emptyFilter": i18n.t('CIVICS.COMMON.SAVE_SEARCH_NO_FILTERS_TO_SAVE_ERROR') } }, this);
				return;
			}
			const searchExists = this.savedSearchesCollection.find(model => model.get('name') === searchName);
			if (!searchExists && this.savedSearchesCollection.length < this.config.maxSavedSearches) {
				// Create a new instance of the model and set attributes
				const newSearch = new save_search_model({
					"name": searchName,
					"searchData": minifiedFilter,
					"isDefault": false,
					"source": this.config.filterType === "tasks" ? 'inspections' : 'projects'
				});

				// Save the new search to the server
				newSearch.save(null, {
					success: () => {
						this.savedSearchesCollection.add(newSearch); // Update the collection with the new search
						dashboardChannel.trigger('saveSearches:update', this.savedSearchesCollection.toJSON());
						this.closeSaveSearchModal();
					},
					error: () => {
						ViewManager.errorToWindow({ validationError: { "saveError": i18n.t('CIVICS.COMMON.SAVE_SEARCH_FAIL') } }, this);
					}
				});
			} else if (searchExists) {
				ViewManager.errorToWindow({ validationError: { "savedSearchExists": i18n.t('CIVICS.COMMON.SAVE_SEARCH_EXISTS') } }, this);
			} else {
				ViewManager.errorToWindow({ validationError: { "saveSearchMax": i18n.t('CIVICS.COMMON.SAVE_SEARCH_REACHED_MAX_SEARCH_ERROR') } }, this);
			}
		},
		closeSaveSearchModal: function () {
			if(this.modalRegion) {
				this.modalRegion.hideModal();
			} else {
				this.destroy();
			}
		},
		templateHelpers: function() {
			return {
				config: this.config,
			};
		},
	});
});
